import { render, staticRenderFns } from "./ManageClientsEmployee.vue?vue&type=template&id=e716bc7c&"
import script from "./ManageClientsEmployee.vue?vue&type=script&lang=js&"
export * from "./ManageClientsEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports